import React, { memo } from "react"
import { ThemeManager } from "../../theme-manager/theme-manager";
import { NewsletterMainContent } from "./newsletter-main-content";
import { ThemeContext } from "styled-components";
import { Header } from "../header/header";
import { Footer } from "../footer/footer";
import { MainLayoutWrapper } from "../main-layout/main-layout";
import { moduleSettings } from "../../stores/module-settings.store";
const _NewsletterMainLayout = () => {
    const backgroundImageUrl = moduleSettings.backgroundImageUrl;
    const bodyBackgroundColor = backgroundImageUrl
        ? "transparent"
        : moduleSettings.bodyBackgroundColor;
    return (
        <MainLayoutWrapper
            data-test="newsletter-main-layout"
            bodyBackgrounColor={bodyBackgroundColor}
            backgroundImage={backgroundImageUrl}
            id="newsletter-main-layout"
        >
            < ThemeContext.Provider value={ThemeManager.getTheme()} >
                <Header />
                <NewsletterMainContent />
                <Footer />

            </ThemeContext.Provider >

        </MainLayoutWrapper>

    )
};

export const NewsletterMainLayout = memo(_NewsletterMainLayout);